// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2Ulb2","info":"PatientInfo_info__IkG9a"};